import { useState } from "react";
import { Button } from "@/components/ui/button";
import type { WhatsAppDiaDoResumo } from "@/types/whatsapp";
import { resumoPorDia, type DiaDoResumo } from "./resumo-timeline";

const DIAS_VISIVEIS = 5;

function diasDoHistorico(historico: WhatsAppDiaDoResumo[]): DiaDoResumo[] {
  return historico.map((dia) => {
    const [, mes, diaDoMes] = dia.data.split("-");
    return { data: `${diaDoMes}/${mes}`, texto: dia.texto };
  });
}

/**
 * Resumo da conversa com um dia por linha: os dias mais recentes à vista e o
 * resto em "Carregar mais". Resumo antigo sem `historico` é quebrado pelas
 * datas da prosa; sem datas, aparece como texto corrido.
 */
export function WhatsAppLinhaDoTempo({
  historico,
  resumo,
}: {
  historico: WhatsAppDiaDoResumo[] | null;
  resumo: string;
}) {
  const [mostrarTudo, setMostrarTudo] = useState(false);
  const dias = historico?.length ? diasDoHistorico(historico) : resumoPorDia(resumo);
  if (!dias) {
    return <p className="whitespace-pre-wrap text-sm">{resumo}</p>;
  }

  const ocultos = mostrarTudo ? 0 : Math.max(dias.length - DIAS_VISIVEIS, 0);
  return (
    <div className="space-y-1.5">
      {ocultos > 0 && (
        <Button
          variant="link"
          size="sm"
          className="h-auto p-0 text-xs"
          onClick={() => setMostrarTudo(true)}
        >
          Carregar mais ({ocultos} {ocultos === 1 ? "dia anterior" : "dias anteriores"})
        </Button>
      )}
      <ol className="space-y-1.5">
        {dias.slice(ocultos).map((dia, indice, visiveis) => (
          <li key={`${dia.data}-${indice}`} className="flex gap-3 text-sm">
            <span className="w-28 shrink-0 tabular-nums text-muted-foreground">{dia.data}</span>
            <span className={indice === visiveis.length - 1 ? "font-medium" : undefined}>
              {dia.texto}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}
